import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { DatePipe, KeyValue } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm, NgModel } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subject, debounceTime, filter, startWith } from 'rxjs';
import { CustommatdateService } from 'src/app/module/pierhippla/services/custommatdate.service';
import { DataService } from 'src/app/module/pierhippla/services/data.service';
import { LoggerService } from 'src/app/module/pierhippla/services/logger.service';
import { ValidationService } from 'src/app/module/pierhippla/services/validation.service';
import { AddressService } from 'src/app/shared/address.service';
import { SmartyStreetsService } from 'src/app/shared/smarty-streets.service';
import { AlertComponent } from '../dialog/alert.component';
import { AddressDTO, FormDTO, MemberDTO, Prefrence, ResponseDTO, verifyMemberRequest, verifyMemberResponse } from '../interfaces';
import { CaptchaService } from 'src/app/shared/captcha.service';
import { config } from 'src/app/shared/config';


const today = new Date();
const month = today.getMonth();
const year = today.getFullYear();
const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'MMDDYYYY', // this is how your date will be parsed from Input
  },
  display: {
    dateInput: 'MM/DD/YYYY', // this is how your date will get displayed on the Input
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-laform',
  templateUrl: './laform.component.html',
  styleUrls: ['./laform.component.css'],
  providers: [
    { provide: DateAdapter, useClass: CustommatdateService },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class LaformComponent implements OnInit , OnChanges, AfterViewInit{
  public datePipe: DatePipe;
  timerReset: number = 0;
  apiError: HttpErrorResponse | undefined;
  captchaText: string = '';
  pdfForm: any;
  addressSuggestions: any = {
    resAddress: [],
    mailAddress: [],
    referralPolicyAddress: [],
    referralEmployerAddress: []
  }


  ngAfterContentChecked(): void {
    this.changeDetector?.detectChanges();
  }

  verifyMember: verifyMemberRequest = {
    firstNm: '',
    lastNm: '',
    ssnNum: '',
    dobDt: '',
    pierId: null,
  };
  memberObj1: MemberDTO = {
    firstNm: '',
    miNm: '',
    lastNm: '',
    suffixNm: '',
    dobDt: '',
    ssnNum: '',
    gencd: '',
    rshcd: 'SELF',
    dueDate: null,
    enrolledInPolicy: false,
    pregnant: false,
    existingMember: false,
    maNum:'',
    memberPierId: null,
  };

  resAddressFormControl = new FormGroup({
    addressType: new FormControl('R'),
    addressLine1: new FormControl(''),
    addressLine2: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value:'',disabled: true}),
    zipCd: new FormControl(''),
    countyCd: new FormControl({value:'',disabled: true})
  });

  mailAddressFormControl = new FormGroup({
    addressType: new FormControl('M'),
    addressLine1: new FormControl(''),
    addressLine2: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value:'',disabled: true}),
    zipCd: new FormControl(''),

  });


  referralPolicyAddressFormControl = new FormGroup({
    address1Txt: new FormControl(''),
    address2Txt: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value:'',disabled: true}),
    zipCd: new FormControl('')
  });


  referralEmployerAddressFormControl = new FormGroup({
    address1Txt: new FormControl(''),
    address2Txt: new FormControl(''),
    cityTxt: new FormControl(''),
    stateCd: new FormControl({value:'',disabled: true}),
    zipCd: new FormControl('')
  });

  submittedResponse: ResponseDTO = {
    referralId: undefined,
    pdfBytes: '',
  };
  formLa: FormDTO = {
    referralCase: {
      referralSource: '',
      emailTxt: '',
      phone1Num: '',
      phone2Num: '',
      homeLess: false,
      submittingByPH: false,
      submitterFirstName: '',
      submitterLastName: '',
      updateReason: '',
      pierId: '',
      existingCase: false,
      paperLess: false,
    },
    referralEmployer: {
      emplyrFein: '',
      emplyrNm: '',
      address1Txt: '',
      address2Txt: '',
      cityTxt: '',
      stateCd: '',
      zipCd: '',
      phone1Num: '',
    },
    referralPolicy: {
      sourceCd: '',
      carrierNm: '',
      address1Txt: '',
      address2Txt: '',
      cityTxt: '',
      stateCd: '',
      zipCd: '',
      phone1Num: '',
      planName: '',
      groupNum: '',
      policyNum: '',
      policyStartDate: null,
      employeePremium: '',
      frequency: '',
      planTier: '',
      planDeductible: '',
    },
    referralAddressList: [],
    referralMemberList: [],
  };
  additionalMaxReached: boolean = false;
  familyMemberPierId!: string | null;
  editExstingFamilyMember: boolean = false;
  existingInvalidMemberName: string = '';

  constructor(
    private dataService: DataService,
    private logger: LoggerService,
    private deviceDetectorService: DeviceDetectorService,
    private dialog: MatDialog,
    private changeDetector: ChangeDetectorRef,
    private sanitize: DomSanitizer,
    private smartyStreetsService: SmartyStreetsService,
    private addressService: AddressService,
    private renderer: Renderer2, private el: ElementRef,
    private captchaService: CaptchaService
  ) {
    this.timerStart(15);
    this.datePipe = new DatePipe('en-US');
  }

  @ViewChild('residentialAddress') inputField!: ElementRef<HTMLInputElement>;
  @ViewChild('mailingAddress') mailingAddress!: ElementRef<HTMLInputElement>;
  @ViewChild('emplyrAddress') emplyrAddress!: ElementRef<HTMLInputElement>;
  @ViewChild('policyAddress') policyAddress!: ElementRef<HTMLInputElement>;
  previousValRes: any;
  previousValMail: any;
  previousValRefEmp: any;
  previousValRefPol: any;

  ngAfterViewInit() {
    // Disable browser autocomplete for the input field
    if(this.inputField){
      this.inputField.nativeElement.setAttribute('autocomplete', 'new-password');
      // Optional: Programmatically focus on the input field
      this.inputField.nativeElement.focus();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.errorMessageIntialData != '') {
      this.errorMessage = this.getMessageServerDown();
      setTimeout(() => {
        this.changeResetMessage();
        this.errorMessage = '';
      }, 10000);
    }
  }

  // alertDialogData: IAlertDialogData = {
  //   title: 'Session Timer',
  //   content: `
  //   <br />
  //   <p>Your session is about to end, and your changes will not be saved. </p>
  //   <p> Would you like to extend your session?</p>
  //   <br />
  //       `,
  //   confirmButtonText: ''
  // };

  @Input() preference: Prefrence | null = null;
  @Input() email: string | undefined = '';
  @Input() tollfreeNo: string | undefined | null = '';
  @Input() faxNo: string | undefined | null = '';
  @Input() address: string = '';
  @Input() emailTo: string = '';

  @ViewChild('customerForm')
  customerForm: NgForm = {} as NgForm;

  @ViewChild('captcha')
  captcha: NgModel = {} as NgModel;

  @ViewChild('MemberSsn')
  MemberSsn: NgModel = {} as NgModel;

  @ViewChild('otherSsn')
  otherSsn: NgModel = {} as NgModel;

  @ViewChild('otherDob')
  otherDob: NgModel = {} as NgModel;

  existingMemberFn() {
    this.updateReason = '';
    this.updateReasonRequired = false;
    this.refferalSourceRequired = false;
    this.firstNameRequired = false;
    this.lastNameRequired = false;
    this.memberSexRequired = false;
    this.homelessRequired = false;
    this.ssnMemberRequired = false;
    this.memberDobRequired = false;
    this.memberMedicateRequired = false;
    this.pregnantMemberRequired = false;
    this.resAddress1Required = false;
    this.resCityRequired = false;
    this.resStateRequired = false;
    this.resZipRequired = false;
    this.isSameRequired = false;
    this.mailAddress1Required = false;
    this.mailParishRequired = false;
    this.mailCityRequired = false;
    this.mailStateRequired = false;
    this.mailZipRequired = false;
    this.addMember = false;
  }

  goForward() {
    if (this.policyHolderCheck() && this.checkPage2Valid() && !this.employerPolicyCheck()) {
      if (this.existingMember == 'No') {
        this.eplyrNmRequired = true;
        if(this.referralEmployerAddressFormControl.controls.address1Txt.value ==""){
          this.emplyrAddr1Required = true;
        } 
        this.emplyrPhoneRequired = true;
        this.emplyrFeinRequired = true;
      }
      this.sourceCdRequired = true;
      if (this.existingMember == 'Yes') {
        this.premiumAmountRequired = true;
        this.deductibleRequired = true;
        this.frequencyRequired = true;
        this.planTierRequired = true;
      }
    }
    this.timerReset =Math.random()* 100;
  }
  goBack() {
    this.maNumRequired = false;
    this.dueDateRequired=false;
    this.sourceCdRequired = false;
    this.premiumAmountRequired = false;
    this.deductibleRequired = false;
    this.frequencyRequired = false;
    this.planTierRequired = false;
    this.eplyrNmRequired = false;
    this.emplyrAddr1Required = false;
    this.emplyrAddr2Required = false;
    this.emplyrCityRequired = false;
    this.emplyrStateRequired = false;
    this.emplyrZipCodeRequired = false;
    this.emplyrPhoneRequired = false;
    this.emplyrFeinRequired = false;
    this.policyStateRequired = false;
  }

  checkPage2Valid() {
    if(!this.referralEmployerAddressFormControl.valid) {
      return false;
    }
    if(!this.referralPolicyAddressFormControl.valid) {
      return false;
    }
    return true;
  }

  goForward2() {
    if (
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      !this.familyMemberCheck()
    ) {
      this.isFamilyRequired = true;
    }
    if (this.pregnantOther == 'Yes') {
      this.otherDueDateRequired = true;
    }

    if (!this.checkAdditionalMembers()) {
      this.additionalMembersReq = true;
    } else {
      this.additionalMembersReq = false;
    }
    if (
      this.isFamilyMemberMedicate == 'Yes' &&
      this.formLa.referralMemberList.length > 50
    ) {
      this.additionalMaxReached = true;
    } else {
      this.additionalMaxReached = false;
    }
    if (
      this.otherfirstNm != '' &&
      this.otherlastNm != '' &&
      (this.otherdobDate != null && this.otherDob!=null &&  this.otherDob.control.value !='') &&
      this.otherEnrolled != '' &&
      this.otherrshcdRf != '' && 
      this.othergencdRf !='' && (this.othergencdRf =='M' || (this.othergencdRf == 'F' && this.pregnantOther != ''))
    ) {
      this.addClearFamilyFilled = true;
    } else {
      this.addClearFamilyFilled = false;
    }
    this.timerReset =Math.random()* 100;
  }
  goBack2() {
    this.isFamilyRequired = false;
    this.additionalMembersReq = false;
    this.additionalMaxReached = false;
    this.otherFnRequired = false;
    this.otherLnRequired = false;
    this.otherEnrolledRequired = false;
    this.pregnantOtherRequired = false;
    this.otherDueDateRequired = false;
    this.otherDobRequired = false;
    this.addClearFamilyFilled = false;
    this.otherRsRequired = false;
    this.otherGnRequired = false;
  }
  goForward3() {
    if (
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.familyMemberCheck() &&
      !this.rightsResponsibilityCheck()
    ) {
      this.signCheckRequired = true;
    }
    this.timerReset =Math.random()* 100;
  }
  goBack3() {
    this.signCheckRequired = false;
  }
  goForward4() {this.timerReset =Math.random()* 100;}
  goForward5() {
    if (
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.familyMemberCheck() &&
      this.rightsResponsibilityCheck() &&
      this.voterRegistrationCheck()
    ) {
      this.signElectronicRequired = true;
      this.signApplicantRequired = true;
      this.signfirstNmRequired = true;
      this.signLastNameRequired = true;
      this.captchaRequired = true;
    }
    if (this.submitCheck()) {
      this.submit();
    }
    this.timerReset =Math.random()* 100;
  }
  goBack5() {
    this.signElectronicRequired = false;
    this.signApplicantRequired = false;
    this.signfirstNmRequired = false;
    this.signLastNameRequired = false;
    this.captchaRequired = false;
  }

  farword() {
    if (this.existingMember != '') {
      if (this.existingMember == 'Yes' && this.updateReason == '') {
        this.updateReasonRequired = true;
      }
      if (this.existingMember == 'No') {
        this.refferalSourceRequired = true;
      }
      if (this.isMemberMedicaid == 'Yes') {
        this.maNumRequired = true;
      }
      if (this.pregnantMember == 'Yes') {
        this.dueDateRequired = true;
      }
      this.firstNameRequired = true;
      this.lastNameRequired = true;
      this.homelessRequired = true;

     if(this.homeLess=='Yes'){
      this.homelessCountyRequired = true;
     }

     if(this.homeLess == 'No') {
      console.log('validateAdress on go farword');

      this.validateAdress(<AddressDTO>this.resAddressFormControl.getRawValue(), this.resAddressFormControl, this.addressSuggestions?.resAddress?.length);
      if(this.isSameMailingAddress == 'No'){
        this.validateAdress(<AddressDTO>this.mailAddressFormControl.getRawValue(), this.mailAddressFormControl, this.addressSuggestions?.mailAddress?.length);
      }
    }

      if (this.MemberSsn.value == '') {
        this.ssnMemberRequired = true;
      }
      if (this.memberObj1.gencd == 'F' && this.isMemberMedicaid == 'Yes') {
        this.pregnantMemberRequired = true;
      }

      this.memberDobRequired = true;
      this.memberMedicateRequired = true;
      this.memberSexRequired = true;

      if(this.resAddressFormControl.controls.addressLine1.value ==""){
        this.resAddress1Required = true;
      }
      this.isSameRequired = true;
      if(this.isSameMailingAddress =='No' && this.mailAddressFormControl.controls.addressLine1.value ==""){
        this.mailAddress1Required = true;
      }
    } else {
      this.updateReasonRequired = false;
      this.refferalSourceRequired = false;
      this.firstNameRequired = false;
      this.lastNameRequired = false;
      this.homelessRequired = false;
      this.homelessCountyRequired = false;
      this.ssnMemberRequired = false;
      this.memberDobRequired = false;
      this.pregnantMemberRequired = false;
      this.memberMedicateRequired = false;
      this.resAddress1Required = false;
      this.resCityRequired = false;
      this.resStateRequired = false;
      this.resZipRequired = false;
      this.isSameRequired = false;
      this.mailAddress1Required = false;
      this.mailParishRequired = false;
      this.mailCityRequired = false;
      this.mailStateRequired = false;
      this.mailZipRequired = false;
    }
    this.timerReset =Math.random()* 100;
  }
  signApplicantCheck() {
    if (this.signApplicant == 'self' || this.signApplicant == 'onbehalf') {
      this.formLa.referralCase.submitterFirstName = '';
      this.formLa.referralCase.submitterLastName = '';
    }
  }
  voteLink: any;
  downloadLink: any;
  disableSearch = false;

  ngOnInit(): void {
    this.captchaText = this.captchaService.generateCaptcha();
    this.voteLink = this.sanitize.bypassSecurityTrustUrl(
      'http://www.geauxvote.com/'
    );
    this.downloadLink =
      this.sanitize.bypassSecurityTrustUrl('javascript:void(0)');
    this._success.subscribe((message) => (this.successMessage = message));
    this._success.pipe(debounceTime(5000)).subscribe(() => {
      this.successMessage = '';
      //window.location.reload();
    });
    this._danger.subscribe((message) => (this.errorMessage = message));
    this._danger.pipe(debounceTime(3000)).subscribe(() => {
      this.errorMessage = '';
      //window.location.reload();
    });
    this._warning.subscribe((message) => (this.warningMessage = message));
    this._warning.pipe(debounceTime(2000)).subscribe(() => {
      this.warningMessage = '';
      if (!(window as any).__KARMA_TEST_MODE__) {
        window.location.reload();
      }
    });

    let resAddressLine1 = this.resAddressFormControl.controls.addressLine1;
    this.resAddressFormControl.controls.addressLine1.valueChanges.pipe(
      startWith(''),
      filter(() => !this.disableSearch),
      debounceTime(1000),
    ).subscribe(val => {
      if(this.disableSearch || !val ) return;
      if(this.resAddressFormControl.controls.zipCd.value) return;
      if(val?.length<6){
        this.previousValRes="";
      }
      if (this.previousValRes?.trim() == resAddressLine1?.value?.trim()) return;      
      if(
        this.resAddressFormControl.controls.addressLine1.value =='PO BOX') {
        this.addressSuggestions.resAddress = [];
        return
      }
      if(val?.length>5){
        this.setPreviousVal(val, 'resAddress');
        this.fetchAddressList(this.resAddressFormControl, this.resAddressFormControl.controls.addressLine1,'LA', true, 'resAddress');
      }
  })

  let mailAddressLine1 = this.mailAddressFormControl.controls.addressLine1;
    this.mailAddressFormControl.controls.addressLine1.valueChanges.pipe(
      startWith(''),
      filter(() => !this.disableSearch),
      debounceTime(1000),
    ).subscribe(val => {
      if(this.disableSearch || !val ) return;
      if(val?.length<6){
        this.previousValMail="";
      }
      if (this.previousValMail?.trim() == mailAddressLine1?.value?.trim()) return;
      if(this.mailAddressFormControl.controls.zipCd.value) return;
      if(val?.length>5){
        this.setPreviousVal(val, 'mailAddress');
        this.fetchAddressList(this.mailAddressFormControl, this.mailAddressFormControl.controls.addressLine1, '', false, 'mailAddress');
      }
    })

  let refEmpAddressLine1 = this.referralEmployerAddressFormControl.controls.address1Txt;
  this.referralEmployerAddressFormControl.controls.address1Txt.valueChanges.pipe(
    startWith(''),
    filter(() => !this.disableSearch),
    debounceTime(1000),
  ).subscribe(val => {
    if(this.disableSearch || !val ) return;
    if(val?.length<6){
      this.previousValRefEmp="";
    }
    if (this.previousValRefEmp?.trim() == refEmpAddressLine1?.value?.trim()) return;
    if(this.referralEmployerAddressFormControl.controls.zipCd.value) return;
    if(val?.length>5){
      this.setPreviousVal(val, 'referralEmployerAddress');
      this.fetchAddressList(this.referralEmployerAddressFormControl, this.referralEmployerAddressFormControl.controls.address1Txt, '', false, 'referralEmployerAddress')
    }  
  })

  let refPolAddressLine1 = this.referralPolicyAddressFormControl.controls.address1Txt;
  this.referralPolicyAddressFormControl.controls.address1Txt.valueChanges.pipe(
    startWith(''),
    filter(() => !this.disableSearch),
    debounceTime(1000),
  ).subscribe(val => {
    if(this.disableSearch || !val ) return;
    if(val?.length<6){
      this.previousValRefPol="";
    }
    if (this.previousValRefPol?.trim() == refPolAddressLine1?.value?.trim()) return;
    if(this.referralPolicyAddressFormControl.controls.zipCd.value) return;
    if(val?.length>5){
      this.setPreviousVal(val, 'referralPolicyAddress');
      this.fetchAddressList(this.referralPolicyAddressFormControl, this.referralPolicyAddressFormControl.controls.address1Txt, '', false, 'referralPolicyAddress')
    }  
  })

  }

  openVoterForm(){
    this.pdfForm = this.preference?.voterForm;
    this.openForm('VoterRegistrationForm.pdf')
  }

  openW9Form(){
    this.pdfForm = this.preference?.w9Form;
    this.openForm('W9Form.pdf')
  }

  openEFTForm(){
    this.pdfForm = this.preference?.eftForm;
    this.openForm('EFTForm.pdf')
  }

  openForm(anchorName : string){
    let bytes = this.pdfForm
    let response = this.base64ToArrayBuffer(bytes);
    let file = new Blob([response], { type: 'application/pdf' });
    let fileURL: any = URL.createObjectURL(file);
    let anchor = document.createElement('a');
    anchor.href = fileURL;
    anchor.download = anchorName;
    anchor.click();
  }

  // Method to check if an address contains a PO Box
isPOBox(address:string):boolean {
  const poBoxPatterns = [/P\.?O\.?\s?Box/i, /Post\s?Office\s?Box/i];
  // Add more patterns if needed
  return poBoxPatterns.some(pattern =>
  pattern.test(address));
}

generateCaptcha(): void {
  this.captchaText = this.captchaService.generateCaptcha();
}
playCaptchaAudio(): void {
  this.captchaService.playCaptchaAudio();
}

fetchAddressList(formGroup: FormGroup, control: FormControl, requiredState: string, stateRestrciton: boolean, propName: string) {
  if(control.value.length > 5){
    const resAddress = formGroup.getRawValue();
    let address1Line = this.capitalize(control.value.toLowerCase());
    let existingAddress = this.addressSuggestions[propName].filter((item: any)  => 
      item.street_line?.includes(address1Line));
    if(this.addressSuggestions[propName].length >0 && existingAddress.length>0){
      this.addressSuggestions[propName] = existingAddress;
     
    }else{
      this.addressService.autocompleteAddress(resAddress, requiredState, stateRestrciton).then(
        (data:any)=> {
          if(propName=='resAddress'){
            const filteredResults = data.suggestions.filter((result: { street_line: string; }) =>!this.isPOBox(result?.street_line));
            this.addressSuggestions[propName] = filteredResults;
          } else {
            this.addressSuggestions[propName] = data.suggestions;
          }
          // this.initRequest[propName] = false;
          if(this.addressSuggestions[propName].length ==0) {
            if( resAddress.cityTxt=='' || resAddress.stateCd=='' ||resAddress.zipCd==''){
              control.setErrors({...(control.errors || {}),'invalid': true});
            }else{
              if(control.errors)
                  delete  control.errors['invalid'];
            }
          }
        }
      );
    }
    
  }else{
    this.addressSuggestions[propName] =[];
  }
  
}
capitalize(value: string): string {
  if (!value) return value;
  return value
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

  model2: string | undefined;
  private _success = new Subject<string>();
  private _warning = new Subject<string>();
  private _danger = new Subject<string>();
  staticAlertClosed = false;
  ssnValidationError: string = '';
  signFirstName: string = '';
  signLastName: string = '';
  signApplicant: string = '';
  signReadCheck: boolean = false;
  signElectronicSignatureChecked: boolean = false;
  homeLess: string = '';
  isSameMailingAddress: string = '';
  isHealthInsurance: string = '';
  isMemberMedicaid: string = '';
  existingMember: string | null = null;
  existingOtherMember: string | null = null;
  existingMemberVerified: boolean = false;
  updateReason: string = '';
  sourceCdRequired: boolean = false;
  premiumAmountRequired: boolean = false;
  deductibleRequired: boolean = false;
  frequencyRequired: boolean = false;
  planTierRequired: boolean = false;
  isFamilyRequired: boolean = false;
  signCheckRequired: boolean = false;
  signElectronicRequired: boolean = false;
  signApplicantRequired: boolean = false;
  signfirstNmRequired: boolean = false;
  signLastNameRequired: boolean = false;
  captchaRequired: boolean = false;
  editIndex?: number = undefined;
  otherFnRequired: boolean = false;
  otherLnRequired: boolean = false;
  otherSsnRequired: boolean = false;
  otherMaNumRequired: boolean = false;
  otherDobRequired: boolean = false;
  otherGnRequired: boolean = false;
  otherRsRequired: boolean = false;
  otherDueDateRequired: boolean = false;
  memberSexRequired: boolean = false;
  otherEnrolledRequired: boolean = false;
  addClearFamilyFilled: boolean = false;
  pregnantMemberRequired: boolean = false;
  pregnantOtherRequired: boolean = false;
  additionalMembersReq: boolean = false;
  resAddress1Required: boolean = false;
  eplyrNmRequired: boolean = false;
  emplyrAddr1Required: boolean = false;
  emplyrAddr2Required: boolean = false;
  emplyrCityRequired: boolean = false;
  emplyrStateRequired: boolean = false;
  emplyrZipCodeRequired: boolean = false;
  emplyrPhoneRequired: boolean = false;
  emplyrFeinRequired: boolean = false;
  resCityRequired: boolean = false;
  resStateRequired: boolean = false;
  resZipRequired: boolean = false;
  isSameRequired: boolean = false;
  mailAddress1Required: boolean = false;
  mailParishRequired: boolean = false;
  mailCityRequired: boolean = false;
  mailStateRequired: boolean = false;
  mailZipRequired: boolean = false;
  updateReasonRequired: boolean = false;
  refferalSourceRequired: boolean = false;
  policyStateRequired: boolean = false;
  firstNameRequired: boolean = false;
  lastNameRequired: boolean = false;
  ssnMemberRequired: boolean = false;
  memberDobRequired: boolean = false;
  memberMedicateRequired: boolean = false;
  homelessRequired: boolean = false;
  homelessCountyRequired: boolean = false;
  maNumRequired: boolean = false;
  dueDateRequired:boolean=false;


  showResAddress: boolean = false;
  showMailAddress: boolean = false;
  showEmployerAddress: boolean = false;
  showPolicyAddress: boolean = false;
  stateRestrciton: boolean = false;
  requiredState: string = '';

  successMessage: string = '';
  warningMessage: string = '';
  pregnantMember: string = '';
  pregnantOther: string = '';
  otherEnrolled: string = '';
  cobra: string = '';
  isFamilyMemberMedicate: string = '';
  captchaEntered: string = '';
  isValidFormSubmitted: boolean = false;
  errorMessage: string = '';
  operationText = 'Submit';
  // @Input() contextCd: string = '';
  // @Input() subContextCd: string = '';
  @Input() errorMessageIntialData: string = '';
  isSsnPresentDB: boolean = false;
  memberVOdobDt!: Date;
  memberVODuedate!: Date | null;
  policyVOpolicyStartDate!: Date;
  cobraStartDate!: Date;
  cobraEndDate!: Date;
  otherdobDate!: Date | null;
  otherMemberDueDate!: Date | null;
  addFamilyMemberButton: boolean = false;
  homeLessPhone1Num: string = '';
  homeLessEmailTxt: string = '';
  addMember: boolean = false;
  memberPierId: string | null = null;
  otherMemberPierId: string | null = null;

  today: Date = today;
  plus1year: Date = new Date(year + 1, month, today.getDate());
  prev10year: Date = new Date(year - 10, month, today.getDate());
  next5year: Date = new Date(year + 5, month, today.getDate());
  prev100year: Date = new Date(year - 100, month, today.getDate());

  originalOrder = (
    a: KeyValue<string, string>,
    b: KeyValue<string, string>
  ): number => {
    return 0;
  };

  otherfirstNm: string = '';
  otherlastNm: string = '';
  othermiNm?: string = '';
  otherssnNum: string = '';
  othersuffixNm?: string = '';
  othermaNum?: string = '';
  othergencdRf?: string = '';
  otherrshcdRf?: string = '';
  otherdobDt: string = '';
  parish: string = '';
  display: any;
  homelessCounty: string = '';
  alreadySubmitted: boolean = false;

  checkCaptch(event: any) {
    if (
      this.captchaEntered != '' &&
      this.captchaEntered != this.captchaText
    ) {
      this.captcha.control.setErrors({ nomatch: true });
      return false;
    } else {
      this.captcha.control.setErrors(null);
      return true;
    }
  }

  submit() {
    if (this.captchaEntered == '') {
      return;
    } else if (this.captchaEntered != this.captchaText) {
      return;
    }
    this.pregnantMember == 'Yes';

    this.existingOtherMember = 'No';
    if(this.memberPierId == null && this.formLa.referralMemberList.length > 0){

      this.formLa.referralMemberList.forEach(mem => {
        if (mem.memberPierId != null){
          this.otherMemberPierId=  mem.memberPierId;
          this.existingOtherMember = 'Yes';
          mem.memberPierId = null;
        }

      });
    }else if(this.memberPierId == null && this.formLa.referralMemberList.length == 0 ){
      this.otherMemberPierId=  null;
    }

    if (this.existingMember == 'Yes' || (this.formLa.referralMemberList.length > 0 && this.existingOtherMember == 'Yes')) {
      this.formLa.referralCase.existingCase = true;
      this.formLa.referralCase.pierId = this.memberPierId!=null? this.memberPierId: this.otherMemberPierId;
    }


    if (this.existingMember == 'Yes') {
      // this.memberObj1.existingMember = true;
      this.formLa.referralCase.updateReason = this.updateReason;
    }

    // this.formLa.referralMemberList.pregnant=this.pregnantOther=='Yes';

    // //this.formLa.clientCd = this.preference?.contextDtl?.clientCode;
    // this.formLa.referralCase.existingMember = this.existingMember == 'Yes';
    // if(this.existingMember == 'Yes'){
    //   this.formLa.referralCase.updateReason = this.updateReason;
    // }
    if(this.homeLess =='Yes'){
      //this.resAddress.countyCd= this.homelessCounty;
      this.resAddressFormControl.patchValue({countyCd: this.homelessCounty})
      //this.formLa.referralCase.phone1Num= this.homeLessPhone1Num?.replaceAll('-','');
      //this.formLa.referralCase.emailTxt= this.homeLessEmailTxt;
    }
    if(this.isSameMailingAddress =='Yes'){
      this.mailAddressFormControl.patchValue(this.resAddressFormControl.getRawValue())

    }
    this.formLa.referralAddressList.push(<AddressDTO>this.resAddressFormControl.getRawValue());
    if(this.isSameMailingAddress=='No'){
      this.formLa.referralAddressList.push(<AddressDTO>this.mailAddressFormControl.getRawValue());
    }
    this.formLa.referralCase.homeLess = this.homeLess == 'Yes';
    this.formLa.referralCase.submittingByPH = this.signApplicant == 'self';
    this.memberObj1.dobDt = this.getServerDate(this.memberVOdobDt);

    if (this.pregnantMember == 'Yes') {
      this.memberObj1.pregnant = true;
      this.memberObj1.dueDate = this.getServerDate(this.memberVODuedate);
    }
    this.formLa.referralPolicy.policyStartDate = this.getServerDate(
      this.policyVOpolicyStartDate
    );

    if (
      this.isFamilyMemberMedicate == 'No' &&
      this.formLa.referralMemberList.length > 0
    ) {
      this.formLa.referralMemberList = [];
    }
    this.formLa.referralMemberList.push(this.memberObj1);
    this.formLa.referralMemberList?.forEach((object) => {
      if (object.ssnNum != '') {
        object.ssnNum = object.ssnNum.replaceAll('-', '');
        object.memberPierId = null;
      }
    });

    let premiumAmt = this.formLa.referralPolicy.employeePremium;
    if (premiumAmt == '') premiumAmt = '0';
    this.formLa.referralPolicy.employeePremium = parseFloat(
      premiumAmt!
    ).toFixed(2);

    this.memberObj1.enrolledInPolicy = this.isMemberMedicaid == 'Yes';

    let frequency = this.formLa.referralPolicy.frequency;
    if (frequency == '' || frequency == '0.00') frequency = '0';
    this.formLa.referralPolicy.frequency = frequency;

    let mempierid=this.formLa.referralCase.pierId;
    if (mempierid == '' || mempierid == null) {
      this.formLa.referralCase.pierId = '0';
      this.formLa.referralCase.existingCase = false;
    } else {
      this.formLa.referralCase.pierId =mempierid;
    }

    let planDeductible = this.formLa.referralPolicy.planDeductible;
    if (planDeductible == '') planDeductible = '0';
    this.formLa.referralPolicy.planDeductible = parseFloat(
      planDeductible!
    ).toFixed(2);

    this.formLa.referralCase.phone1Num =
      this.formLa.referralCase.phone1Num?.replaceAll('-', '');
    this.formLa.referralCase.phone2Num =
      this.formLa.referralCase.phone2Num?.replaceAll('-', '');
    this.formLa.referralPolicy.phone1Num =
      this.formLa.referralPolicy.phone1Num?.replaceAll('-', '');
    this.formLa.referralEmployer.phone1Num =
      this.formLa.referralEmployer.phone1Num?.replaceAll('-', '');
    this.formLa.referralEmployer.emplyrFein =
      this.formLa.referralEmployer.emplyrFein?.replaceAll('-', '');
    this.formLa.referralEmployer.zipCd =
      this.formLa.referralEmployer.zipCd?.replaceAll('-', '');
    this.formLa.referralAddressList?.forEach((object) => {
      if (object.zipCd != '') {
        object.zipCd = object.zipCd?.replaceAll('-', '');
      }
    });
    this.formLa.referralPolicy.zipCd =
      this.formLa.referralPolicy.zipCd?.replaceAll('-', '');
    if (!this.alreadySubmitted) {
      this.alreadySubmitted = true;
      this.warningMessage =
      'Processing your request, please wait.... <div class="spinner-border text-primary" role="status"></div>';
    window.scrollTo(0, 0);
      this.dataService.insertCustomerForm(this.formLa).subscribe({
        next: (response: ResponseDTO) => {
          if (response) {
            this.warningMessage = '';
            this.successMessage =
              'Your application has been submitted successfully.';
            // Mark form as pristine so that CanDeactivateGuard won't prompt before navigation
            //this.referral.memberVOLst.pop();
            this.isValidFormSubmitted = true;
            this.submittedResponse = response;
            setTimeout(() => {
              this.successMessage = '';
            }, 2000);
            //console.log('ResponseId: '+insertedCustomer.reponseID)
            //this.router.navigate(['/customers']);
            clearInterval(this.timer);
            let addMins: number = 0;
            addMins = 15 - this.seconds / 60;
            this.timerStart(addMins);
          } else {
            this.formLa.referralMemberList.pop();
            const msg = 'Unable to save customer details';
            this.errorMessage = msg;
          }
          window.scrollTo(0, 0);
        },
        error: (err: HttpErrorResponse) => {
          this.warningMessage = '';
          this.logger.log(err.message);
          this.apiError = err;
          const msg = 'We are unable to save application details currently, please contact customer support.';
          this.errorMessage = msg;
          window.scrollTo(0, 0);
          this.isValidFormSubmitted = true;
          setTimeout(() => {
            this.errorMessage = '';
          }, 3000);
        },
      });

      if (this.errorMessage != '') {
        window.scrollTo(0, 0);
        this.customerForm?.resetForm();
      }
    }
  }
  addFamilyMember(event: Event) {
    this.addClearFamilyFilled = false;
    let valid = true;
    const form = this.customerForm?.form;

    if (form != null) {
      let page1 = [
        'isFamilyMemberMedicate',
        'otherfirstNm',
        'othermiNm',
        'otherlastNm',
        'othersuffixNm',
        'otherssnNum',
        'd6',
        'othergencdRf',
        'd7',
        'otherrshcdRf',
        'pregnantOther',
        'otherEnrolled',
        'othermaNum',
      ];
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
        }
      }
    }
   

    if (this.othergencdRf == 'M') {
      this.pregnantOther = '';
      this.otherMemberDueDate = null;
    }
    if (this.formLa.referralMemberList.length > 50) {
      this.additionalMaxReached = true;
    }
    if (this.pregnantOther == 'Yes' && this.otherMemberDueDate == null) {
      this.otherDueDateRequired = true;
      valid = false;
    }
    if (valid && !this.additionalMaxReached) {
      this.addFamilyMemberButton = true;
      (event.target as HTMLButtonElement).disabled = true;
      if (
        (this.otherdobDate != null && this.otherDob!=null && this.otherDob.control.value !='') &&
        this.otherfirstNm != '' &&
        this.otherlastNm != '' &&
        this.othergencdRf != '' &&
        this.otherEnrolled != '' &&
        this.otherssnNum != '' &&
        this.othermaNum != '' &&
        this.otherrshcdRf != '' && (this.othergencdRf =='M' || (this.othergencdRf == 'F' && this.pregnantOther != ''))
      ) {
        if (this.memberObj1.ssnNum == this.otherssnNum) {
          this.ssnValidationError = 'Duplicate ssn in the form';
          this.otherSsn.control.setErrors({ duplicate: true });
          return;
        }
        let otherdueDate: string | null = null;
        if (this.pregnantOther == 'Yes') {
          otherdueDate = this.getServerDate(this.otherMemberDueDate);
        }
        if (this.editIndex != undefined) {
          this.formLa.referralMemberList.splice(this.editIndex, 1);
          this.editIndex = undefined;
        }

        let otherMembPierId: string |null =null;
        if(this.memberPierId == null && this.formLa.referralMemberList.length > 0){

          this.formLa.referralMemberList.forEach(mem => {
            if (otherMembPierId == null && mem.memberPierId != null){
              otherMembPierId=  mem.memberPierId;
            }
          });
        }


        this.verifyMember.dobDt = this.getServerDate(this.otherdobDate);
        this.verifyMember.ssnNum = this.otherssnNum;
        this.verifyMember.pierId = this.memberPierId != null? this.memberPierId: otherMembPierId;
        this.verifyMember.firstNm = this.otherfirstNm;
        this.verifyMember.lastNm = this.otherlastNm;
        this.verifyMember.ssnNum = this.verifyMember.ssnNum.replaceAll('-', '');

        this.dataService.getVerifyExistingMember(this.verifyMember).subscribe({
          next: (response: verifyMemberResponse) => {
            if (response) {
              if (response.addMember == true && response.existingMember == true && response.pierId != null) {
                this.otherMemberPierId = response.pierId;
                this.existingOtherMember = 'Yes';
              }
              this.addMember = response.addMember;

            }

            if (!this.addMember) {
              this.existingInvalidMemberName =
                this.verifyMember.firstNm + ' ' + this.verifyMember.lastNm;
              this.addFamilyMemberButton = false;
              this.openValidateMemberDialog();
              return;
            } else {
              if(this.otherfirstNm !='' && this.otherlastNm != '' && this.otherssnNum !=''){
              this.formLa.referralMemberList.push({
                dobDt: this.getServerDate(this.otherdobDate),
                firstNm: this.otherfirstNm,
                lastNm: this.otherlastNm,
                miNm: this.othermiNm,
                ssnNum: this.otherssnNum,
                suffixNm: this.othersuffixNm,
                maNum: this.othermaNum,
                gencd: this.othergencdRf,
                rshcd: this.otherrshcdRf,
                dueDate: otherdueDate,
                enrolledInPolicy: this.otherEnrolled == 'Yes',
                pregnant: this.pregnantOther == 'Yes',
                existingMember: this.existingOtherMember == 'Yes',
                memberPierId: this.otherMemberPierId,
              });
            }
              this.checkAdditionalMembers();
                this.additionalMembersReq = false;
                this.addClearFamilyFilled = false;
                this.clear(event);
                this.otherdobDate = null;
                this.otherdobDt = '';
                this.otherfirstNm = '';
                this.otherlastNm = '';
                this.othermiNm = '';
                this.otherssnNum = '';
                this.othersuffixNm = '';
                (this.othermaNum = ''), (this.othergencdRf = '');
                this.otherrshcdRf = '';
                this.otherMemberDueDate = null;
                if (this.pregnantOther == 'Yes') {
                  this.pregnantOther = 'No';
              this.otherMemberPierId = null;
              this.existingOtherMember= '';
            }
           }
          },
          error: (err: HttpErrorResponse) => {
                this.logger.logMsg(err.error);
                const msg =
                  'We are unable to verify  Member details currently, please contact customer support at (877) 697-6703';
                this.errorMessage = msg;
                window.scrollTo(0, 0);
                setTimeout(() => {
                  this.errorMessage = '';
                }, 3000);
          },
        });
      } else {
        if (this.otherfirstNm == '') {
          this.otherFnRequired = true;
        }
        if (this.otherlastNm == '') {
          this.otherLnRequired = true;
        }
        if (this.otherEnrolled == '') {
          this.otherEnrolledRequired = true;
        }
        if (this.pregnantOther == '') {
          this.pregnantOtherRequired = true;
        }
        if (this.pregnantOther == 'Yes' && this.otherMemberDueDate == null) {
          this.otherDueDateRequired = true;
        }
        if (this.otherssnNum == '') {
          this.otherSsnRequired = true;
        }
        if (this.othermaNum == '') {
          this.otherMaNumRequired = true;
        }
        if (this.otherDob.control.value == null || this.otherDob.control.value =='') {
          this.otherDobRequired = true;
        }
        if (this.othergencdRf == '') {
          this.otherGnRequired = true;
        }
        if (this.otherrshcdRf == '') {
          this.otherRsRequired = true;
        }
        this.addFamilyMemberButton = false;
      }
      (event.target as HTMLButtonElement).disabled = false;
    }else{
      if (this.otherfirstNm == '') {
        this.otherFnRequired = true;
      }
      if (this.otherlastNm == '') {
        this.otherLnRequired = true;
      }
      if (this.otherEnrolled == '') {
        this.otherEnrolledRequired = true;
      }
      if (this.pregnantOther == '') {
        this.pregnantOtherRequired = true;
      }
      if (this.pregnantOther == 'Yes' && this.otherMemberDueDate == null) {
        this.otherDueDateRequired = true;
      }
      if (this.otherssnNum == '') {
        this.otherSsnRequired = true;
      }
      if (this.othermaNum == '') {
        this.otherMaNumRequired = true;
      }
      if (this.otherDob.control.value == null || this.otherDob.control.value =='') {
        this.otherDobRequired = true;
      }
      if (this.othergencdRf == '') {
        this.otherGnRequired = true;
      }
      if (this.otherrshcdRf == '') {
        this.otherRsRequired = true;
      }
    }
  }

  clear(event: Event) {
    this.goBack3();
    this.addClearFamilyFilled = false;
    this.otherFnRequired = false;
    this.otherLnRequired = false;
    this.otherEnrolledRequired = false;
    this.pregnantOtherRequired = false;
    this.otherSsnRequired = false;
    this.otherMaNumRequired = false;
    this.otherDobRequired = false;
    this.otherGnRequired = false;
    this.otherRsRequired = false;
    this.otherdobDt = '';
    this.otherfirstNm = '';
    this.otherlastNm = '';
    this.othermiNm = '';
    this.otherssnNum = '';
    this.othersuffixNm = '';
    this.othermaNum = '';
    this.othergencdRf = '';
    this.otherrshcdRf = '';
    this.otherdobDate = null;
    if(this.otherDob && this.otherDob.control){
      this.otherDob.control.setValue('');
      this.otherDob.control.setErrors(null);
    }
    this.otherMemberDueDate = null;
    this.pregnantOther = '';
    this.otherEnrolled = '';
    if (this.pregnantOther == 'Yes') {
      this.pregnantOther = 'No';
    }
    this.addMember = true;
  }
  cancel(event: Event) {
    event.preventDefault();
    this.changeResetMessage();
    window.scrollTo(0, 0);
  }

  removeMember(memberIndex: number): void {
    const [removedUser] = this.formLa.referralMemberList.splice(memberIndex, 1);
    if (this.formLa.referralMemberList.length == 0) {
      this.additionalMembersReq = true;
    }
    if (this.formLa.referralMemberList.length <= 50) {
      this.additionalMaxReached = false;
    }

    if(removedUser?.existingMember && removedUser.memberPierId) {
      this.otherMemberPierId = null;
      this.existingOtherMember = 'No';
    }

  }


  editMember(memberIndex: number): void {
    let obj = this.formLa.referralMemberList[memberIndex];

    this.editIndex = memberIndex;
    this.otherfirstNm = obj.firstNm;
    this.otherlastNm = obj.lastNm;
    this.otherssnNum = obj.ssnNum;
    this.othersuffixNm = obj.suffixNm;
    this.othermaNum = obj.maNum;
    this.othermiNm = obj.miNm;
    this.othergencdRf = obj.gencd;
    this.otherrshcdRf = obj.rshcd;
    this.otherdobDate = moment(obj.dobDt, 'MM/DD/YYYY').toDate();
    this.otherEnrolled = obj.enrolledInPolicy ? 'Yes' : 'No';
    // this.existingMember = obj.existingMember ? 'Yes' : 'No';
    if (obj.dueDate != null) {
      this.pregnantOther = 'Yes';
      this.otherMemberDueDate = moment(obj.dueDate, 'MM/DD/YYYY').toDate();
    } else {
      this.pregnantOther = 'No';
      this.otherMemberDueDate = null;
    }
  }

  getServerDate(dateStruct: Date | null) {
    if (dateStruct != null) {
      return this.datePipe.transform(dateStruct, 'MM/dd/yyyy');
    }
    return null;
  }
  public changeSuccessMessage() {
    this._success.next(`${new Date()} - Form submitted successfully.`);
  }
  public changeResetMessage() {
    this._warning.next(` Form reset done.`);
  }
  allowAlphabets(event: any) {
    return ValidationService.allowAlphabets(
      event,
      this.deviceDetectorService.browser
    );
  }
  allowAlphabets2(event: any, control: NgModel) {
    return ValidationService.allowAlphabets2(
      event,
      this.deviceDetectorService.browser,
      control
    );
  }
    allowAlphaNumericWithSplChars(event: any,control: NgModel){
      return ValidationService.allowAlphaNumericWithSplChars(
        event,
        this.deviceDetectorService.browser,
        control
      );
  
  
    }
    allowAlphaNumericWithTwoSplChar(event: any, control: NgModel){
      return ValidationService.allowAlphaNumericWithTwoSplChar(
        event,
        this.deviceDetectorService.browser,
        control
      );
    }
    allowAlphaNumericForCarrier(event: any, control: NgModel){
        return ValidationService.allowAlphaNumericForCarrier(
          event,
          this.deviceDetectorService.browser,
          control
        );
    }
    allowAlphaNumericWithoutSpace(event: any, control: NgModel) {
      return ValidationService.allowAlphaNumericWithoutSpace(
        event,
        this.deviceDetectorService.browser,
        control
      );
    }
  allowAlphaNumericWithSpace(event: any, control: NgModel) {
    return ValidationService.allowAlphaNumericWithSpace(
      event,
      this.deviceDetectorService.browser,
      control
    );
  }

  isNumeric(elem: any, control: NgModel) {
    return ValidationService.isNumeric2(
      elem,
      this.deviceDetectorService.browser,
      control
    );
  }

  oneSpaceAllowed(event: any) {
    return ValidationService.oneSpaceAllowed(event);
  }

  allowAlphaNumeric(event: any) {
    return ValidationService.allowAlphaNumeric(
      event,
      this.deviceDetectorService.browser
    );
  }
  allowAlphaNumericWithSplHash(event: any) {
    return ValidationService.allowAlphaNumericWithSplHash(
      event,
      this.deviceDetectorService.browser
    );
  }
  validatePremiumAmountFormat(event: any) {
    return ValidationService.validatePremiumAmountFormat(
      event,
      this.deviceDetectorService.browser
    );
  }
  ssnmask(ssn: any, control: NgModel) {
    return ValidationService.ssnmask(ssn, control);
  }

  onFocusInput() {
    //this.addressSuggestions = [];
  }

  async setDefaultBlank(event: any, controlName: string, formGroup: FormGroup, propName: string){
    let cityTxt =formGroup.controls['cityTxt'];
    let stateCd =formGroup.controls['stateCd'];
    let zipCd =formGroup.controls['zipCd'];
     const key = event.keyCode || event.charCode;
     if(this.addressSuggestions[propName].length >0 && event.target.value.length < 6){
      this.addressSuggestions[propName] = [];
    }
   
  if((event.ctrlKey && event.key === 'v') || (event.ctrlKey && event.key === 'c') || key != 37 && key != 38 && key != 39 && key != 40 && event.keyCode!=13 && event.keyCode!= 9){     
    if(cityTxt.value !='' || stateCd.value !='' || zipCd.value !='' || key === 8 || key === 46  ||(event.ctrlKey && event.key === 'x')){
      
        if(controlName =='mailAddress.addressLine1Txt'){
          this.showMailAddress=false;
        }else if(controlName =='caseVO.addressLine1Txt'){
        this.showResAddress=false;
        } else if(controlName =='employerVO.addressLine1Txt') {
          this.showEmployerAddress = false;
        } else if(controlName =='policyVO.addressLine1Txt') {
          this.showPolicyAddress = false;
        }
        formGroup.patchValue({
          addressLine2: '',
          cityTxt: '',
          stateCd: '',
          zipCd: '',
          countyCd: ''
        });
      }
      
    if(controlName =='caseVO.addressLine1Txt' && this.resAddressFormControl.value?.addressLine1?.includes('PO BOX')){
      this.resAddressFormControl.controls.addressLine1.setErrors({'po': true});
    }
  }

  }

  selectSuggestion(fromGroup: FormGroup,name:string, control: FormControl, suggestion: any, trigger: any, propName: string) {
    if(suggestion?.option?.value?.secondary && suggestion?.option?.value?.entries > 1 ){
      this.disableSearch = true;
      const selectedAddress = suggestion?.option?.value?.street_line +' '+ suggestion?.option?.value?.secondary + ' ('+suggestion?.option?.value?.entries + ') '+
      suggestion?.option?.value?.city +' '+ suggestion?.option?.value?.state +' '+ suggestion?.option?.value?.zipcode;
      control.setValue(suggestion?.option?.value?.street_line.toUpperCase());

      this.addressSuggestions[propName] = [];
      this.setPreviousVal(suggestion?.option?.value?.street_line, propName);      
      this.addressService.autocompleteSelectedAddress(suggestion?.option?.value?.street_line.toUpperCase(), selectedAddress).then(
        (data:any)=> {
          this.addressSuggestions[propName] = data.suggestions;
          if(trigger) {
            trigger.openPanel();
          }
          setTimeout (() => {
            this.disableSearch = false;
          },9000)

        }
      )

      console.log("Address Suggestions: "+this.addressSuggestions);
    }  else{
    // selectSuggestion(control: NgModel, suggestion: any) {
      const address: AddressDTO = {
        addressType: '',
        addressLine1: '',
        addressLine2: '',
        cityTxt: '',
        stateCd: '',
        zipCd: '',
        countyCd: ''
      };
      
      this.addressSuggestions[propName] = [];
      control.setValue(suggestion?.option?.value?.street_line.toUpperCase());
      if(name =='mailAddress.addressLine1Txt'){
        address.addressType ='M';
        this.showMailAddress=true;
        this.addressService.setAddressDetails(address,suggestion);
        this.mailAddressFormControl.patchValue(address);
      } else if(name =='employerVO.addressLine1Txt'){
        this.showEmployerAddress=true;
        this.addressService.setAddressDetails(address,suggestion);
        this.referralEmployerAddressFormControl.patchValue(address);
        delete address.countyCd;
        this.formLa.referralEmployer = {...this.formLa.referralEmployer, ...address, address1Txt: address.addressLine1, address2Txt: address.addressLine2 };
      } else if(name =='policyVO.addressLine1Txt'){
        this.showPolicyAddress = true;
        this.addressService.setAddressDetails(address,suggestion);
        this.referralPolicyAddressFormControl.patchValue(address);
        delete address.countyCd;
        this.formLa.referralPolicy = {...this.formLa.referralPolicy, ...address, address1Txt: address.addressLine1, address2Txt: address.addressLine2 };
      } else if(name =='caseVO.addressLine1Txt'){
        address.addressType ='R';

        this.addressService.setAddressDetails(address,suggestion);
        // if(address?.addressLine1?.includes('PO BOX')){
        //   this.resAddressFormControl.controls.addressLine1.setErrors({'po': true});
        //   return;
        // }
        this.showResAddress=true;
        this.resAddressFormControl.patchValue(address);
        this.smartyStreetsService.getCountyByAddress(suggestion?.option?.value?.street_line, suggestion?.option?.value?.city, suggestion?.option?.value?.state).subscribe(
          (data: any) => {
            if(name =='caseVO.addressLine1Txt'){
              //this.resAddress.countyCd = (data[0].metadata.county_name);
              if(data[0].components.plus4_code){
                this.resAddressFormControl.patchValue({
                  zipCd: this.resAddressFormControl.value.zipCd += '-' + data[0].components.plus4_code
                })
                //this.resAddress.zipCd += '-' + data[0].components.plus4_code;
              }

              if(this.preference != null && this.preference.dropDownValues != null){
                let countyList =  this.preference.dropDownValues['COUNTYCD'];
                this.resAddressFormControl.patchValue({
                  countyCd: this.getKeyByValue(countyList, data[0].metadata.county_name.toUpperCase())
                });
                //this.resAddress.countyCd = this.getKeyByValue(countyList, data[0].metadata.county_name.toUpperCase());
            }
            }
          },
          (error) => {
            console.log('Error fetching county suggestions:', error);
          }
        );
      }
    }
  }

  getKeyByValue(object: Record<string, string>, value: string): string | undefined {
    return Object.keys(object).find(key => object[key] === value);
  }

  phonemask2(phone: any, control: NgModel) {
    return ValidationService.phonemask2(phone, control);
  }

  datemask2(date: any, control: NgModel) {
    return ValidationService.datemask2(date, control);
  }
  onlyNumeric(elem: any, control: NgModel) {
    return ValidationService.onlyNumeric(
      elem,
      this.deviceDetectorService.browser,
      control
    ); 
  }
  isFEINValidValue(empFEIN: any, control: NgModel) {
    this.phoneCheck(empFEIN, control);
    let isValid = ValidationService.isFEINValidValue(empFEIN.target.value);
    if (!isValid) {
      control.control.setErrors({ ...(control.errors || {}), invalid: true });
    } else {
      if (control.control.errors) delete control.control.errors['invalid'];
    }
  }
  empFEINMask(empFEIN: any, control: NgModel) {
    return ValidationService.empFEINMask(empFEIN, control);
  }
  amountMask(amount: any, control: NgModel) {
    return ValidationService.amountMask(amount, control);
  }
  validateAmount(amount: any, control: NgModel) {
    return ValidationService.validateAmount(amount, control);
  }

  getSSNUsedMessage() {
    return ValidationService.getSSNUsedMessage2(this.faxNo);
  }
  getMessageServerDown() {
    return ValidationService.getMessageServerDown();
  }

  isPregnantMember() {
    this.memberVODuedate = null;
    this.pregnantMemberRequired = false;
  }

  verifySSN(event: any, isOtherSsn: boolean, control: NgModel) { 
    this.phoneCheck(event,control);
    let ssn = event.target.value;
    let donepatt = /^(\d{3})-(\d{2})-(\d{4})$/;
    if (ssn.match(donepatt)) {
      let check: boolean = ValidationService.isSSNValidValue(ssn);
      if (!check) {
        if (!isOtherSsn) {
          this.MemberSsn.control.setErrors({
            ...(this.MemberSsn.control.errors || {}),
            invalidSsn: true,
          });
          return false;
        }
        if (isOtherSsn) {
          this.otherSsn.control.setErrors({
            ...(this.otherSsn.control.errors || {}),
            invalidSsn: true,
          });
          return false;
        }
      }

      if (isOtherSsn && this.memberObj1.ssnNum == ssn) {
        this.ssnValidationError = 'Duplicate ssn in the form';
        this.otherSsn.control.setErrors({
          ...(this.otherSsn.control.errors || {}),
          duplicate: true,
        });
        return false;
      }

      for (let othermember of this.formLa.referralMemberList) {
        if (isOtherSsn && othermember.ssnNum == ssn && (this.editIndex == undefined || this.getIndexByName(ssn) !==this.editIndex )) {
          this.ssnValidationError = 'Duplicate ssn in the form';
          this.otherSsn.control.setErrors({
            ...(this.otherSsn.control.errors || {}),
            duplicate: true,
          });
          return false;
        }
      }
    }

    return false;
  }
  getIndexByName(name: string): number {
    return this.formLa.referralMemberList.findIndex(item => item.ssnNum === name);
  }

  policyHolderCheck() {
    const resAddress = this.resAddressFormControl.getRawValue();
    const mailAddress = this.mailAddressFormControl.getRawValue();
    let requiredFields: boolean =
      this.existingMember != '' &&
      ((this.existingMember == 'No' &&
        this.formLa.referralCase.referralSource != '') ||
        (this.existingMember == 'Yes' && this.updateReason != '')) &&
      this.memberObj1.firstNm != '' &&
      this.memberObj1.lastNm != '' &&
      this.memberObj1.ssnNum != '' &&
      this.memberObj1.gencd != '' &&
      this.memberVOdobDt != null &&
      this.homeLess != '' &&
      this.isMemberMedicaid != '' &&
      (this.isMemberMedicaid == 'No' ||
        (this.isMemberMedicaid == 'Yes' && this.memberObj1.maNum != '')) &&
      ((this.homeLess == 'Yes' && this.homelessCounty != '') ||
        (this.homeLess == 'No' &&
          resAddress.addressLine1 != '' &&
          resAddress.stateCd != '' &&
          resAddress.zipCd != '' &&
          resAddress.cityTxt != '' &&
          this.isSameMailingAddress != '' &&
          ((this.homeLess == 'No' &&
            this.isSameMailingAddress == 'No' &&
            mailAddress.addressLine1 != '' &&
            mailAddress.stateCd != '' &&
            mailAddress.zipCd != '' &&
            mailAddress.cityTxt != '') ||
            (this.homeLess == 'No' && this.isSameMailingAddress == 'Yes'))))
            && (
        (this.isMemberMedicaid == 'Yes' &&
          this.memberObj1.gencd == 'F' &&  this.pregnantMember != '' &&
          this.pregnantMember == 'Yes' &&
          this.memberVODuedate != null) ||
        (this.isMemberMedicaid == 'Yes' &&
          this.memberObj1.gencd == 'F' && this.pregnantMember != '' &&
          this.pregnantMember == 'No') ||
        (this.isMemberMedicaid == 'Yes' && this.memberObj1.gencd == 'M' && this.pregnantMember == '') ||
        (this.isMemberMedicaid == 'No' && this.memberObj1.gencd == 'M' && this.pregnantMember == '')||
        (this.isMemberMedicaid == 'No' && this.memberObj1.gencd == 'F' && this.pregnantMember == ''));
    let valid = true;
    const form = this.customerForm?.form;
    if (requiredFields && form != null) {
      let page1 = [
        'caseVO.referralSource',
        'memberVO.firstNm',
        'memberVO.miNm',
        'memberVO.lastNm',
        'memberVO.suffixNm',
        'memberObj.ssnNum',
        'd1',
        'memberVO.gencdRf',
        'isMemberMedicaid',
        'homeLess',
        'caseVO.addressLine1Txt',
        'caseVO.addressLine2Txt',
        'resparish',
        'caseVO.cityTxt',
        'caseVO.stacdRf',
        'caseVO.zip5Cd',
        'caseVO.phone1Num',
        'caseVO.phone2Num',
        'caseVO.emailTxt',
        'isSameMailingAddress',
        'mailAddress.addressLine1Txt',
        'mailAddress.addressLine2Txt',
        'mailAddress.cityTxt',
        'mailAddress.stacdRf',
        'mailing.zip5Cd',
        'mailingState.phone1Num',
        'homeLessEmailTxt',
        'homeLessPhone1Num',
        'existingMember',
        'updateReason',
        'd2',
        'memberVO.maNum',
      ];
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
        }
      }
    }

    return requiredFields && valid;
  }

  validateAdress(address: AddressDTO, formGroup: FormGroup, suggestionCount: number, force = true) {
    let valid = true;
    let addressControl = formGroup.controls['addressLine1'];
    if(address.addressLine1 =="" ){
      if(addressControl.errors && addressControl.hasError('invalid')){
        if(addressControl.hasError('required')){
          addressControl.setErrors({
            required: true, invalid: false
          });
        }
      }else{
        addressControl.setErrors({
          required: true
        });
      }
      
      valid = false;
    }else if(address.cityTxt =="" || address.stateCd =="" || address.cityTxt =="" ){
      if(!(addressControl.errors && addressControl.hasError('po')) && !(addressControl.errors && addressControl.hasError('invalid'))){
        addressControl.setErrors({invalid: true});
      }     
      valid = false;
    }else{
      if(addressControl.errors && addressControl.hasError('invalid') ){
        if(!addressControl.hasError('po')){
          if(!addressControl.hasError('required'))
            addressControl.setErrors(null);
        }else{
          addressControl.setErrors({
            invalid: false, po: true
          });
        }
      }
        
    }    
    return valid;
  }

  employerPolicyCheck() {
    let requiredFields: boolean =
      this.policyHolderCheck() &&
      this.checkPage2Valid() &&
      this.formLa.referralPolicy.sourceCd != '' &&
      ((this.existingMember == 'Yes' &&
        this.formLa.referralPolicy.employeePremium != '' &&
        this.formLa.referralPolicy.planDeductible != '' &&
        this.formLa.referralPolicy.planTier != '' &&
        this.formLa.referralPolicy.frequency != '') ||
        (this.existingMember == 'No' &&
          this.formLa.referralEmployer.emplyrNm != '' &&
          this.referralEmployerAddressFormControl.controls.address1Txt.value != '' &&
          this.referralEmployerAddressFormControl.controls.cityTxt.value != '' &&
          this.referralEmployerAddressFormControl.controls.stateCd.value != '' &&
          this.referralEmployerAddressFormControl.controls.zipCd.value != '' &&
          this.formLa.referralEmployer.phone1Num != '' &&
          this.formLa.referralEmployer.emplyrFein != ''));
    // && this.formLa.referralPolicy.employeePremium != ''
    //&& this.formLa.referralPolicy.planDeductible != ''
    //&& this.formLa.referralPolicy.planTier !=''
    //&& this.formLa.referralPolicy.frequency !=''

    let valid = true;
    const form = this.customerForm?.form;
    if (requiredFields && form != null) {
      let page1 = [
        'isHealthInsurance',
        'employerVO.emplyrNm',
        'employerVO.addressLine1Txt',
        'employerVO.addressLine2Txt',
        'employerVO.cityTxt',
        'employerVO.stacdRf',
        'employerVO.zip5Cd',
        'employerVO.phone1Num',
        'employerVO.emplyrFein',
        'policyVO.carrierNm',
        'policyVO.addressLine1Txt',
        'policyVO.addressLine2Txt',
        'policyVO.cityTxt',
        'policyVO.stacdRf',
        'policyVO.zip5Cd',
        'policyVO.phone1Num',
        'policyVO.planName',
        'policyVO.policyNum',
        'policyVO.groupNum',
        'd3',
        'premium',
        'Deductible',
        'policyVO.frequency',
        'policyVO.planTier',
      ];
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
          break;
        }
      }
      if(this.referralEmployerAddressFormControl.controls.address1Txt.errors){
        valid = false;
      }
      if(this.referralPolicyAddressFormControl.controls.address1Txt.errors){
        valid = false;
      }
    }

    return requiredFields && valid;
  }

  familyMemberCheck() {
    let requiredFields: boolean =
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&

      this.isFamilyMemberMedicate != '' &&
      ((this.checkAdditionalMembers() && this.isFamilyMemberMedicate != '') ||
        this.isFamilyMemberMedicate == 'No');

    let valid = true;
    const form = this.customerForm?.form;

    if (requiredFields && form != null) {
      let page1 = [
        'isFamilyMemberMedicate',
        'otherfirstNm',
        'othermiNm',
        'otherlastNm',
        'othersuffixNm',
        'otherssnNum',
        'd6',
        'othergencdRf',
        'pregnantOther',
        'd7',
        'otherrshcdRf',
        'otherEnrolled',
        'othermaNum'
      ];
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
        }
      }
    }
    let checkFmailyFilled: boolean = false;
    if (
      this.otherfirstNm != '' &&
      this.otherlastNm != '' &&
      (this.otherdobDate != null && this.otherDob!=null && this.otherDob.control.value !='') &&
      this.otherEnrolled != '' &&      
      this.othermaNum != '' &&
      this.otherrshcdRf != '' && 
      this.othergencdRf !='' &&(this.othergencdRf =='M' || (this.othergencdRf == 'F' && this.pregnantOther != ''))


    ) {
      checkFmailyFilled = true;
    } else {
      checkFmailyFilled = false;
    }

    return (
      requiredFields &&
      valid &&
      !checkFmailyFilled &&
      !(this.isFamilyMemberMedicate == 'No' && this.isMemberMedicaid == 'No')
    );
  }
  checkAdditionalMembers() {
    if (
      this.isFamilyMemberMedicate == 'Yes' &&
      this.formLa.referralMemberList.length == 0
    ) {
      return false;
    } else {
      return true;
    }
  }

  rightsResponsibilityCheck() {
    return (
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.familyMemberCheck() &&
      this.signReadCheck
    );
  }

  voterRegistrationCheck() {
    return (
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.familyMemberCheck() &&
      this.rightsResponsibilityCheck()
    );
  }

  submitCheck() {
    let requiredFields: boolean =
      this.policyHolderCheck() &&
      this.employerPolicyCheck() &&
      this.familyMemberCheck() &&
      this.rightsResponsibilityCheck() &&
      this.voterRegistrationCheck() &&
      this.signElectronicSignatureChecked &&
      this.signApplicant != '' &&
      this.formLa.referralCase.submitterFirstName != '' &&
      this.formLa.referralCase.submitterLastName != '' &&
      this.captchaEntered != '';

    let valid = true;
    const form = this.customerForm?.form;
    if (requiredFields && form != null) {
      let page1 = [
        'signElectronicSignatureChecked',
        'signApplicant',
        'signfirstNm',
        'signLastName',
        'captcha',
      ];
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
        }
      }
    }

    return requiredFields && valid;
  }
  seconds: number = 0;
  timer: any;
  timerStart(minute: number) {
    if (this.seconds > 0) {
      this.seconds = this.seconds + minute * 60;
    } else {
      this.seconds = minute * 60;
    }
    let textSec: any = '0';
    let statSec: number = 60;

    const prefix = Math.floor(this.seconds / 60) < 10 ? '0' : '';

    this.timer = setInterval(() => {
      this.seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      textSec = statSec.toString().padStart(2, '0');
      let minutes = Math.floor(this.seconds / 60)
        .toString()
        .padStart(2, '0');
      this.display = `${minutes}:${textSec}`;
      if (this.seconds == 60 && !this.isValidFormSubmitted) {
        this.openDialog();
      }
      if (this.seconds == 0) {
        console.log('finished');
        window.scrollTo(0, 0);
        if (!(window as any).__KARMA_TEST_MODE__) {
          window.location.reload();
        }
        clearInterval(this.timer);
      }
    }, 1000);
  }

  isMedicaidMember() {
    if (this.isFamilyMemberMedicate == 'No' && this.isMemberMedicaid == 'No') {
      this.openMedicaidDialog();
    }
    this.pregnantMember = '';
    this.memberObj1.maNum = '';
    this.maNumRequired = false;
    this.memberVODuedate = null;
    this.pregnantMemberRequired = false;
    this.dueDateRequired=false;
  }
  isGenderChange(){
    this.pregnantMember = '';
    this.memberVODuedate = null;
    this.pregnantMemberRequired = false;
    this.dueDateRequired=false;
  }
  isGenderOtherChange(){
    this.pregnantOther = '';
    this.pregnantOtherRequired = false;
    this.otherMemberDueDate = null;
    this.otherDueDateRequired = false;

  }
  openMedicaidDialog() {
    const dialogRef = this.dialog.open(AlertComponent, {
      data: {
        title: 'Medicaid Member Required',
        content: `<br />
      <p>At least one member of your family should be a Medicaid recipient to apply for HIPP. <br />Based on your responses, you do not qualify for HIPP.</p>
      <br />`,
        confirmButtonText: '',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        //clearInterval(this.timer);
        //this.timerStart(15);
      } else if (result == false) {
        // this.changeResetMessageCalled.emit('resetForm');
        //window.scrollTo(0, 0);
      }
    });
  }
  isPregnantOther() {
    this.otherMemberDueDate = null;
    this.otherDueDateRequired = false;
  }
  isHomeless(){
    if(this.homeLess =='No'){
      this.resAddressFormControl.patchValue({
        addressLine1: '',
        addressLine2: '',
        stateCd: '',
        zipCd: '',
        cityTxt: ''
      })
      // this.resAddress.addressLine1 ='';
      // this.resAddress.addressLine2 ='';
      // this.resAddress.countyCd ='';
      // this.resAddress.stateCd ='';
      // this.resAddress.zipCd ='';
      // this.resAddress.cityTxt ='';
      //this.formLa.referralCase.emailTxt='';
      //this.formLa.referralCase.phone1Num='';
      this.isSameMailingAddress = '';
    }
    if (this.homeLess == 'Yes') {
      this.homelessCounty = '';
      //this.homeLessPhone1Num='';
      //this.homeLessEmailTxt='';
    }
    this.resAddress1Required = false;
    this.resCityRequired = false;
    this.resStateRequired = false;
    this.resZipRequired = false;
    this.isSameRequired = false;
    this.showResAddress = false;
    this.mailAddress1Required = false;
    this.mailParishRequired = false;
    this.mailCityRequired = false;
    this.mailStateRequired = false;
    this.mailZipRequired = false;
  }
  sameMailingAddress(){
    this.mailAddressFormControl.patchValue({
      addressLine1: '',
      addressLine2: '',
      stateCd: '',
      zipCd: '',
      cityTxt: ''
    })
      // this.mailAddress.addressLine1 ='';
      // this.mailAddress.addressLine2 ='';
      // this.mailAddress.stateCd ='';
      // this.mailAddress.zipCd ='';
      // this.mailAddress.cityTxt ='';

    this.showMailAddress = false;
    this.mailAddress1Required = false;
    this.mailParishRequired = false;
    this.mailCityRequired = false;
    this.mailStateRequired = false;
    this.mailZipRequired = false;
  }

  openDialog() {
    const dialogRef = this.dialog.open(AlertComponent, {
      data: {
        title: 'Session Timer',
        content: `<br />
        <p>Your session is about to end, and your changes will not be saved. </p>
        <p> Would you like to extend your session?</p>
        <br />`,
        confirmButtonText: '',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        clearInterval(this.timer);
        this.timerStart(15);
      } else if (result == false) {
        this.changeResetMessage();
        window.scrollTo(0, 0);
      }
    });
  }

  allowAlphaNumericWithSplChar(event: any) {
    return ValidationService.allowAlphaNumericWithSplChar(
      event,
      this.deviceDetectorService.browser
    );
  }
  allowOnlyOneAlphabet(event: any, control: NgModel) {
    return ValidationService.allowOnlyOneAlphabet(
      event,
      this.deviceDetectorService.browser,
      control
    );
  }
  openPdf() {
    let bytes = this.submittedResponse.pdfBytes;

    let response = this.base64ToArrayBuffer(bytes);
    let file = new Blob([response], { type: 'application/pdf' });
    let fileURL: any = URL.createObjectURL(file);
    //window.open(fileURL);
    let anchor = document.createElement('a');
    anchor.href = fileURL;
    anchor.title = 'Submitted Form';
    anchor.ariaLabel = 'Submitted Form';
    anchor.lang = 'en';
    anchor.type = 'application/pdf';
    anchor.download = this.submittedResponse.referralId + '.pdf';
    anchor.click();
  }
  base64ToArrayBuffer(base64: any): ArrayBuffer {
    let binary_string = window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
  removeSavedFamilyMembers(event: any) {
    if (this.isFamilyMemberMedicate == 'No' && this.isMemberMedicaid == 'No') {
      this.openMedicaidDialog();
    }
    this.formLa.referralMemberList = [];
    this.additionalMaxReached = false;
    this.additionalMembersReq = false;

    this.clear(event);
  }

  verifyMemberFn(dobDt: NgModel) {
    console.log('form', this.resAddressFormControl.getRawValue(), this.mailAddressFormControl.getRawValue());
    let requiredFields: boolean =
      this.memberObj1.firstNm != '' &&
      this.memberObj1.lastNm != '' &&
      this.memberObj1.ssnNum != '' &&
      this.memberVOdobDt != null;

    if (!requiredFields) {
      this.firstNameRequired = true;
      this.lastNameRequired = true;
      this.ssnMemberRequired = true;
      if(!(dobDt.control.errors && dobDt.control.errors['invalidDate'])){
        this.memberDobRequired = true;
      }
    }

    let valid = true;
    const form = this.customerForm?.form;

    if (requiredFields && form != null) {
      let page1 = [
        'memberVO.firstNm',
        'memberVO.lastNm',
        'memberObj.ssnNum',
        'd1',
      ];
      for (let key of page1) {
        if (form.controls[key]?.errors != null) {
          valid = false;
        }
      }
    }

    if (requiredFields && valid) {
      this.existingMemberFn();
      this.verifyMember.firstNm = this.memberObj1.firstNm;
      this.verifyMember.lastNm = this.memberObj1.lastNm;
      this.verifyMember.dobDt = this.getServerDate(this.memberVOdobDt);
      this.verifyMember.ssnNum = this.memberObj1.ssnNum;
      this.verifyMember.pierId = this.memberPierId;

      this.verifyMember.ssnNum = this.verifyMember.ssnNum.replaceAll('-', '');
      this.dataService.getVerifyExistingMember(this.verifyMember).subscribe({
        next: (response: verifyMemberResponse) => {
          if (response) {
            this.memberPierId = response.pierId;
            this.addMember = response.addMember;
            this.existingMember = response.existingMember == true ? 'Yes' : 'No';
            this.memberObj1.existingMember = response.existingMember;
            //this.formLa.referralCase.pierId = response.pierId;

          }
        },
        error: (err: HttpErrorResponse) => {
          this.logger.logMsg(err.error);
          const msg =
            'We are unable to verify Member details currently, please contact customer support at (877) 697-6703';
          this.errorMessage = msg;
          window.scrollTo(0, 0);
          setTimeout(() => {
            this.errorMessage = '';
          }, 3000);
        },
      });
    }
    this.timerReset =Math.random()* 100;
  }

  openValidateMemberDialog() {
    const dialogRef = this.dialog.open(AlertComponent, {
      data: {
        title: 'Family Member',
        content:
          `<br />
      <h1 class="text-danger"><i class="bi bi-exclamation-circle-fill"></i> Invalid Member</h1>
      <p>This member <span class="text-danger">` +
          this.existingInvalidMemberName +
          `</span> details belongs to different case.</p>
      <p>Please verify the member details. </p>
      <br />`,
        confirmButtonText: '',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        //clearInterval(this.timer);
        //this.timerStart(15);
      } else if (result == false) {
        // this.changeResetMessageCalled.emit('resetForm');
        //window.scrollTo(0, 0);
      }
    });
  }
  isMedicaidValid(medicaid: any, control: NgModel) {
    this.phoneCheck(medicaid, control);
    let isValid = ValidationService.isMedicaidValid(medicaid.target.value);
    if (!isValid) {
      control.control.setErrors({ ...(control.errors || {}), invalid: true });
    } else {
      if (control.control.errors) delete control.control.errors['invalid'];
    }
  }
  phoneCheck(event : any, control: NgModel ){
    if(event.target.value =='' && control.control.errors && (control.control.hasError('nomatch') || control.control.hasError('pattern'))){
      if(!control.control.hasError('required')){
        control.control.setErrors(null);
      }else{
        control.control.setErrors({...(control.errors || {}),'nomatch': false, 'required':true});
      }
    }
  }
  nomatchCheck(event : any, control: NgModel ){
    this.phoneCheck(event, control);
  }
  parseDate(date: any, control: NgModel){
    this.phoneCheck(date, control);
    let donepatt = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    if((date.target.value.length > 0 &&  date.target.value.length < 8) ){
      control.control.setErrors({...(control.errors || {}),'invalidDate': true,'required':false});
    }else{
      if(control.control.errors && control.control.hasError('invalidDate'))
      delete  control.control.errors['invalidDate'];
    }
    if(donepatt.test(date.target.value)){
      let parseDate =  moment(date.target.value, 'MM/DD/YYYY');
      if(!parseDate.isValid()){
        control.control.setErrors({...(control.errors || {}),'invalidDate': true,'required':false});
      }else{
        if(control.control.errors && control.control.hasError('invalidDate'))
          delete  control.control.errors['invalidDate'];
      }
    } 
  }
  validateAddress(address1Txt: any, city: any, state: any, zipCd: any){
    if(address1Txt.value != ''){
      if( city.value =="" || state.value =="" || zipCd.value ==""){
        if(!(address1Txt.errors && address1Txt.hasError('po')))
        address1Txt.setErrors({...(address1Txt.errors || {}),'invalid': true,});
      }else{
        if(address1Txt.errors && address1Txt.hasError('invalid'))
          delete  address1Txt.errors['invalid'];
      }
    }else if(address1Txt.errors && !address1Txt.hasError('required')){
      address1Txt.setErrors(null);
    }
    
  }

  private setPreviousVal(tempSelectedStreetLine: any, propName: string) {
    if(config.validateAddresses){
    switch (propName) {
      case 'resAddress': this.previousValRes = tempSelectedStreetLine; break;
      case 'mailAddress': this.previousValMail = tempSelectedStreetLine; break;
      case 'referralEmployerAddress': this.previousValRefEmp = tempSelectedStreetLine; break;
      case 'referralPolicyAddress': this.previousValRefPol = tempSelectedStreetLine; break;
      default: "";
    }
  }
  }
  validateCarrierNm(event : any, control: NgModel ){
    let regex=/^(?![ \-/()])([a-zA-Z0-9]+(?: {0,1}(?:[\-/] {0,1})?[a-zA-Z0-9]+)*)(?: {0,1}\((?![ -])[A-Za-z]+(?:\s{0,1}[A-Za-z]+|\s{0,1}[-]\s{0,1}(?![ -])[A-Za-z]+)*\) *(?:[a-zA-Z0-9]+(?: {0,1}(?:[\-/] *)?[a-zA-Z0-9]+)*)*)?(?![ \-/()])$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
  validatePlanNm(event : any, control: NgModel ){
    let regex=/^(?![ .,\/#&-])[A-Za-z0-9]+(?:\s{0,1}[A-Za-z0-9]+|\s{0,1}[.,\/#&-]\s{0,1}(?![ .,\/#&-])[A-Za-z0-9]+)*$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
  validateGroupNum(event : any, control: NgModel ){
    let regex=/^(?![ -])[A-Za-z0-9]+(?:\s{0,1}[A-Za-z0-9]+|\s{0,1}[-]\s{0,1}(?![ -])[A-Za-z0-9]+)*$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
  validatePolicyId(event : any, control: NgModel ){
    let regex=/^[a-zA-Z0-9]+$/;
    if(event.target.value !='' && !event.target.value.match(regex) ){
      control.control.setErrors({...(control.errors || {}),'nomatch': true});
    }
    else {
      if (control.control.errors) delete control.control.errors['nomatch'];
    }
  }
}
